export default __webpack_public_path__ + "static/how-to-watch-recordings-dark-mode-b54da3ec9038ea2ea572e4561d38b4d2.mp4";